import React, { useState, useCallback, useEffect } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleChevronLeft, faCircleChevronRight, faCircleXmark } from "@fortawesome/free-solid-svg-icons"
import { Link } from "react-router-dom"
import "./wireTestsCapabilities.css"
import logoWireTest from "../../imagens/logos/logoWireTests.png"


function WireTestCapabilities({ listWireTest }) {
    const [slideNumber, setSlideNumber] = useState(0)
    const [openModal, setOpenModal] = useState(false)


    const handleOpenModal = (index) => {
        setSlideNumber(index)
        setOpenModal(true)
    }

    const handleCloseModal = () => {
        setOpenModal(false)
    }

    const prevSlide = useCallback(() => {
        slideNumber === 0 ?
            setSlideNumber(listWireTest.length - 1) :
            setSlideNumber(slideNumber - 1)
    }, [slideNumber, listWireTest.length])

    const nextSlide = useCallback(() => {
        slideNumber + 1 === listWireTest.length ?
            setSlideNumber(0) :
            setSlideNumber(slideNumber + 1)

    }, [slideNumber, listWireTest.length])

    useEffect(() => {
        const handleKeyDown = (event) => {
            switch (event.key) {
                case 'Escape':
                    handleCloseModal()
                    break
                case 'ArrowLeft':
                    prevSlide()
                    break;
                case 'ArrowRight':
                    nextSlide()
                    break;
                default:
                    break;
            }
        };

        if (openModal) {
            window.addEventListener('keydown', handleKeyDown);
        }

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [openModal, nextSlide, prevSlide]);

    return (
        <div>
            {openModal &&
                <div className="wireTestSliderWrap">
                    <FontAwesomeIcon icon={faCircleChevronLeft} onClick={prevSlide} className="wireTestBtnPrev" />
                    <FontAwesomeIcon icon={faCircleChevronRight} onClick={nextSlide} className="wireTestBtnNext" />
                    <FontAwesomeIcon icon={faCircleXmark} onClick={handleCloseModal} className="wireTestBtnClose" />
                    <img className="wireTestFullScreenImage" src={listWireTest[slideNumber].img} alt="" />
                </div>
            }
            <div className="img-custom-size img-fluid ms-2">
                <img src={logoWireTest} alt="logoWireTest"></img>
            </div>

            <div className="wireTestGalleryWrap mx-2">
                {
                    listWireTest && listWireTest.map((image, index) => {
                        return (
                            <div
                                className="wireTestSingle"
                                key={index}
                                onClick={() => handleOpenModal(index)}
                            >

                                <img src={image.img} alt="" />
                            </div>
                        )

                    })

                }
            </div >
            <div className="text-center text-nowrap my-4">
                <Link to="/Capabilities/Production">
                    <button className="buttonCapabilities">Back to Production Capabilities</button>
                </Link>
            </div>
        </div>
    )
}

export default WireTestCapabilities